<template>
  <div class="summary-card">
    <h3 class="insurace-variant-card__title">
      ОСГОП Такси
    </h3>
    <div class="summary-card__row">
      <span class="summary-card__row__desc">
        Соответствует введенному требованию законодательства об
        обязательном страховании ответственности с 1&nbsp;сентября&nbsp;2024&nbsp;года
      </span>
      <span class="summary-card__row__premium">
<!--        Стоимость {{ premium }}&nbsp;₽-->
        <template v-if="quoteStatus">{{ quoteStatus }}</template>
        <template v-else>Стоимость {{ getLocalNumber(getPremium) }}&nbsp;₽</template>
      </span>
    </div>
    <div class="summary-card__row">
      <div v-for="(tariff, id) in tariffs" class="summary-card__row__risk">
        <div class="summary-card__row-tariff-wrapper">
          <span class="summary-card__row-tariff">
            {{tariff?.title ?? ''}}
          </span>
          <span class="summary-card__row-tariff-sum">
            <b>до {{getLocalNumber(Number(tariff?.sum) * (countCars ?? 1)) }}&nbsp;₽</b>
          </span>
        </div>
      </div>
    </div>
    <div class="summary-card__row">
      <div class="summary-card__row__risk">
        <div class="summary-card__row-tariff-wrapper">
          <span class="summary-card__row-tariff">
            Кол-во ТС
          </span>
          <span class="summary-card__row-tariff-sum">
            <b>{{ countCars}}</b>
          </span>
        </div>
      </div>
      <div class="summary-card__row__risk summary-card__row__risk__long">
        <div class="summary-card__row-tariff-wrapper">
          <span class="summary-card__row-tariff">
            Срок договора
          </span>
          <span class="summary-card__row-tariff-sum">
            <b>{{ contractTerm }}</b>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'SummaryCard',

  props: {
    quoteStatus: String,
    contractTerm: {
      type: String,
      default: '12 месяцев',
    },
    premium: Number,
    tariffs: Array,
    newTariffs: Array,
    countCars: Number,
  },

  computed: {
    getPremium() {
      let allPremium = 0;
      const newTariffsLength = this.newTariffs?.length || 0;
      const tariffLength = this.tariffs?.length || 0;

      if (newTariffsLength) {
        for (let i = 0; i < newTariffsLength; i++) {
          allPremium += Number(this.newTariffs[i]?.premium ?? 0);
        }
      } else {
        for (let i = 0; i < tariffLength; i++) {
          allPremium += Number(this.tariffs[i]?.premium ?? 0);
        }
      }

      return Math.round(allPremium * (this.countCars ?? 1) * 100) / 100;
    },
  },
  methods: {
    getLocalNumber(number) {
      if (!!!number) {
        return 0;
      }

      return Number(number).toLocaleString('ru-RU');
    },
  }
};
</script>
<style scoped lang=scss>
  .summary-card {
    $border-radius-desktop: $border-radius-default;
    $padding-desktop: $gap-normal;

    display: flex;
    flex-direction: column;

    flex-shrink: 0;
    border-radius: rem($border-radius-desktop);
    transition: border-color $transition-duration $transition-function;


    padding: rem($padding-desktop);

    border: none;
    background-color: $color-card-background-primary-weekened;

    &__row {
      &-tariff {
        display: block;

        &-wrapper {
          display: inline-block;
        }

        &-wrapper:not(:last-child) {
          border-right: 2px solid black;
          padding-right: 10px;
        }
      }

      &-sum {
        display: block;
      }

      &__risk {
        @include text-small;
        max-width: 31%;
        width: 31%;


        color: $color-text-secondary;

        @media #{$screen-medium} {
          font-size: rem($font-size-mini);
          max-width: 100%;
          width: 100%;
          margin-top: rem(10px);
          border-right: none;
          border-bottom: 1px solid $color-button-background-disabled;
          padding-right: 0;
          padding-bottom: 10px;
        }

        &__long {
          max-width: 66%;
          width: 66%;

          @media #{$screen-medium} {
            max-width: 100%;
            width: 100%;
          }
        }
      }

      &__risk:not(:last-child) {
        border-right: 1px solid $color-button-background-disabled;
        padding-right: 10px;

        @media #{$screen-medium} {
          border-right: none;
          padding-right: 0;
        }
      }

      margin-top: rem(5px);
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: rem(10px);

      @media #{$screen-medium} {
        flex-direction: column;
        align-items: start;
      }

      &__desc {
        display: block;
        max-width: 55%;

        @include text-small;

        color: $color-text-secondary;

        @media #{$screen-medium} {
          font-size: rem($font-size-mini);
          max-width: 100%;
        }
      }

      &__premium {
        display: block;
        max-width: 35%;
        padding: rem(10px);
        $border-radius-desktop: $border-radius-default;
        border-radius: rem($border-radius-desktop);


        @include text-small;


        color: white;
        background-color: #fc4c02;

        @media #{$screen-medium} {
          font-size: rem($font-size-mini);
          max-width: 100%;
          margin-top: rem(10px);
        }
      }
    }
  }
</style>
